import { defineMessages } from 'react-intl';

export default defineMessages({
  unit: {
    id: 'repaymentAgreements.unit',
    defaultMessage: 'Unit',
  },
  hudUnitNumber: {
    id: 'repaymentAgreements.hudUnitNumber',
    defaultMessage: 'HUD Unit #',
  },
  hudUnitNumberTooltip: {
    id: 'repaymentAgreements.hudUnitNumberTooltip',
    defaultMessage:
      'If the HUD Contract Unit # differs from Fortress, it will appear here (if entered) ' +
      'and be reflected on the voucher sent to TRACS. To add one, open the unit and enter ' +
      'the HUD Unit # in General Unit Information.',
  },
  headOfHousehold: {
    id: 'repaymentAgreements.headOfHousehold',
    defaultMessage: 'Head of Household',
  },
  agreementId: {
    id: 'repaymentAgreements.agreementId',
    defaultMessage: 'Agreement ID',
  },
  agreementType: {
    id: 'repaymentAgreements.agreementType',
    defaultMessage: 'Agreement Type',
  },
  agreementStatus: {
    id: 'repaymentAgreements.agreementStatus',
    defaultMessage: 'Status',
  },
  agreementAmount: {
    id: 'repaymentAgreements.agreementAmount',
    defaultMessage: 'Agreement Amount',
  },
  agreementChangeAmount: {
    id: 'repaymentAgreements.agreementChangeAmount',
    defaultMessage: 'Agreement Change Amount',
  },
  totalPayment: {
    id: 'repaymentAgreements.totalPayment',
    defaultMessage: 'Total Payment',
  },
  paymentsRemaining: {
    id: 'repaymentAgreements.paymentsRemaining',
    defaultMessage: 'Payments Remaining',
  },
  actions: {
    id: 'repaymentAgreements.actions',
    defaultMessage: 'Actions',
  },
  modify: {
    id: 'repaymentAgreements.modify',
    defaultMessage: 'Modify',
  },
  modifyDisabledTooltip: {
    id: 'repaymentAgreements.modifyDisabledTooltip',
    defaultMessage:
      'You can only modify a repayment if it has been approved on a previous voucher. ' +
      'If you would like to make changes, please delete this record and add a new one.',
  },
  delete: {
    id: 'repaymentAgreements.delete',
    defaultMessage: 'Delete',
  },
  deleteDisabledTooltip: {
    id: 'repaymentAgreements.deleteDisabledTooltip',
    defaultMessage:
      'Cannot delete repayment agreements from vouchers that have been paid.',
  },
  tableTitle: {
    id: 'repaymentAgreements.tableTitle',
    defaultMessage: 'Repayment Agreements',
  },
  agreementDate: {
    id: 'repaymentAgreements.agreementDate',
    defaultMessage: 'Agreement Date',
  },
  emptyStateMessage: {
    id: 'repaymentAgreements.emptyStateMessage',
    defaultMessage:
      'There are no Repayment Agreements to submit on this voucher.',
  },
  guidanceMessage: {
    id: 'repaymentAgreements.guidanceMessage',
    defaultMessage:
      'If a Repayment Agreement below is in an incorrect status, please go to the' +
      " resident's profile > Qualification tab to make the necessary changes.",
  },
  scheduledForTracsSubmission: {
    id: 'repaymentAgreements.scheduledForTracsSubmission',
    defaultMessage: 'Scheduled for TRACS Submission',
  },
  endingBalance: {
    id: 'repaymentAgreements.endingBalance',
    defaultMessage: 'Ending Balance',
  },
  amountRetained: {
    id: 'repaymentAgreements.amountRetained',
    defaultMessage: 'Amount Retained',
  },
  requestedAmount: {
    id: 'repaymentAgreements.requestedAmount',
    defaultMessage: 'Requested Amount',
  },
  approvedAmount: {
    id: 'repaymentAgreements.approvedAmount',
    defaultMessage: 'Approved Amount',
  },
  addNewButton: {
    id: 'repaymentAgreements.addNewButton',
    defaultMessage: 'Add New',
  },
  loadError: {
    id: 'repaymentAgreements.loadError',
    defaultMessage: 'Failed to load repayment agreements. Please try again.',
  },
  createSuccess: {
    id: 'repaymentAgreements.createSuccess',
    defaultMessage: 'Repayment agreement created successfully.',
  },
  modifySuccess: {
    id: 'repaymentAgreements.modifySuccess',
    defaultMessage: 'Repayment agreement updated successfully.',
  },
  createError: {
    id: 'repaymentAgreements.createError',
    defaultMessage: 'Failed to create repayment agreement. Please try again.',
  },
  modifyError: {
    id: 'repaymentAgreements.modifyError',
    defaultMessage: 'Failed to update repayment agreement. Please try again.',
  },
  unitResidentRequired: {
    id: 'repaymentAgreements.unitResidentRequired',
    defaultMessage:
      'Unit / Resident selection is required for this agreement type.',
  },
  deleteSuccess: {
    id: 'repaymentAgreements.deleteSuccess',
    defaultMessage: 'Repayment agreement removed from voucher successfully.',
  },
  deleteError: {
    id: 'repaymentAgreements.deleteError',
    defaultMessage: 'Failed to remove repayment agreement. Please try again.',
  },
  voucherStatusUpdatedTitle: {
    id: 'repaymentAgreements.voucherStatusUpdatedTitle',
    defaultMessage: 'Voucher Status Updated',
  },
  voucherReturnedToDraft: {
    id: 'repaymentAgreements.voucherReturnedToDraft',
    defaultMessage:
      'The voucher has been returned to Draft status. A new submission will be required.',
  },
  carriedOverWarningBanner: {
    id: 'repaymentAgreements.carriedOverWarningBanner',
    defaultMessage:
      'Existing Repayment Agreements must be updated to reflect any payments or balance changes ' +
      'prior to Voucher submission.',
  },
  updateApprovedAmountError: {
    id: 'repaymentAgreements.updateApprovedAmountError',
    defaultMessage: 'Unable to update approved amount. Please try again.',
  },
  updateApprovedAmountSuccess: {
    id: 'repaymentAgreements.updateApprovedAmountSuccess',
    defaultMessage: 'Approved amount updated successfully.',
  },
});
